export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-Heavy.72595b67.woff";